import { VersionType } from "../__generated__/generated_types";
import { useChartOfAccounts } from "../contexts/chartofaccounts/ChartOfAccountsContext";
import { useProperties } from "../contexts/properties/PropertiesContext";
import { useVersions } from "../contexts/versions/VersionsContext";

export type AppConfig = ReturnType<typeof useConfig>;

export type localUserPrefs = {
    selectedVersionType: VersionType,
}

export function useConfig() {
    const properties = useProperties();
    const chartOfAccountsConfig = useChartOfAccounts();
    const versions = useVersions();

    return  {
        isReady: properties.loaded && chartOfAccountsConfig.isReady,
        // The defaults for year and startReforecastMonthIndex should never be used, but
        // are there to ensure the type is good.
        year: properties.currentProperty?.reforecastYear ?? (new Date()).getFullYear(),
        startReforecastMonthIndex: properties.currentProperty?.reforecastStartMonthIndex ?? 0,
        properties,
        chartOfAccountsConfig,
        versions
    };

}